// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__3Huz0","minWidth":"grid_minWidth__1Tbui"};